import { render, staticRenderFns } from "./productCatalog.vue?vue&type=template&id=3bf0564a&scoped=true&"
import script from "./productCatalog.vue?vue&type=script&lang=js&"
export * from "./productCatalog.vue?vue&type=script&lang=js&"
import style0 from "./productCatalog.vue?vue&type=style&index=0&id=3bf0564a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf0564a",
  null
  
)

export default component.exports